import { Injectable } from '@angular/core';

import {
  SecurityService,
  ConfigurationService,
  InitialStateService,
  SystemStatusService
} from '@tdwb/core';

/**
 * Configures initial page
 */
@Injectable()
export class WebbrokerInitPageService {

  private static readonly LINK_DI_HOME_PAGE: string = 'link_home_page';
  private static readonly LINK_LITE_HOME_PAGE: string = 'link_home_page_lite';
  private static readonly LINK_SYSTEM_ERROR: string = 'link_system_error';
  private static readonly LINK_MAINTENANCE: string = 'link_system_maintenance';
  private static readonly LINK_NEW_USER: string = 'link_new_user';
  private static readonly LINK_HIGH_LOAD: string = 'link_balances';
  private static readonly LINKS_INITIAL: Array<string> = [
    'link_balances',
    'link_holdings',
    'link_balances_performance',
    'link_activity',
    'link_your_goals',
    'link_advanced_dashboard',
    'link_markets_research',
    'link_new_issues',
    'link_learn'
  ];

  constructor(private configurationService: ConfigurationService,
              private securityService: SecurityService,
              private systemStatusService: SystemStatusService,
              private initialStateService: InitialStateService) {
  }

  // Configure default routing states for the application
  // Check if we are on SYSTEM_DOWN mode, navigates to system error
  // Else if is on MAINTENANCE_MODE, navigates to system maintenance
  // Else if this is a NEW_USER flow, navigates to New user page
  // Else if is on HIGH_LOAD mode, normal navigation but forces home_page to last
  // Else configure the proper page list
  init(): void {
    let preferredLinkId = this.configurationService.getProperty<string>('userPreferences.WBT_START_PAGE');
    let linkIds = [...WebbrokerInitPageService.LINKS_INITIAL];

    if (this.systemStatusService.isSystemDown()) {
      linkIds = [WebbrokerInitPageService.LINK_SYSTEM_ERROR];
    } else if (this.systemStatusService.isMaintenanceMode()) {
      linkIds = [WebbrokerInitPageService.LINK_MAINTENANCE];
    } else if (this.securityService.hasPermission('NEW_USER')) {
      linkIds = [WebbrokerInitPageService.LINK_NEW_USER];
    } else if (this.systemStatusService.isHighLoadMode()) {
      if (preferredLinkId === WebbrokerInitPageService.LINK_DI_HOME_PAGE
        || preferredLinkId === WebbrokerInitPageService.LINK_LITE_HOME_PAGE) {
        // when in high load we want to avoid users navigating to home page and send them to balances instead
        preferredLinkId = WebbrokerInitPageService.LINK_HIGH_LOAD;
      }
      linkIds.push(WebbrokerInitPageService.LINK_DI_HOME_PAGE);
      linkIds.push(WebbrokerInitPageService.LINK_LITE_HOME_PAGE);
    } else {
      linkIds.unshift(WebbrokerInitPageService.LINK_LITE_HOME_PAGE);
      linkIds.unshift(WebbrokerInitPageService.LINK_DI_HOME_PAGE);
    }

    this.initialStateService.init(linkIds, WebbrokerInitPageService.LINK_SYSTEM_ERROR, preferredLinkId);
  }

}
